// extracted by mini-css-extract-plugin
module.exports = {"title":"ListTitle_title__Fdqub"};